// A list of all the search param keys used in the app's URL (they are not the ones passed in the API calls to backend)
// Used to avoid typos and to make sure all keys are used in the same way
export enum PaginationParamKeys {
  OrderBy = 'orderBy',
  Page = 'page',
  SearchTerm = 'searchTerm',
  SortOrder = 'sortOrder',
  Types = 'types',
}

export enum FilteringParamKeys {
  AssetStatus = 'assetStatus', // Assets individual status
  ProductTypeName = 'productTypeName',
  Warranty = 'warranty',
  ExcludeAssigned = 'excludeAssigned',
  AssignedToEmployeeId = 'assignedToEmployeeId',
  EolStatus = 'osSupportStatus',
  IsDevice = 'isDevice',
  MDMStatus = 'mdmStatus',
  HealthStatus = 'healthStatus',
  GroupMembershipType = 'groupMembershipType',
  HideUnusedGroups = 'hideUnusedGroups',
}

export enum NavigationParamKeys {
  Tab = 'tab',
  Modal = 'modal',
  ScrollTo = 'scrollTo',
  IntegrationTab = 'integrationTab',
  BillingTab = 'billingTab',
}

export enum SortingParamKeys {
  Column = 'sortCol',
  Direction = 'sortDir',
}

export enum SelectionParamKeys {
  EmployeeId = 'employeeId',
  ProductId = 'productId',
  AssetId = 'assetId',
  /** Storefront: asset to add to the cart on load (unlike `assetId`, which only opens its details modal) */
  CartAssetId = 'cartAssetId',
  HrisEmployeeId = 'hrisEmployeeId',
}

export enum AuthenticationParamKeys {
  OrganizationApp = 'organization_app',
}

export enum IsolvedParamKeys {
  TenantId = 'tenantId',
  ClientId = 'clientId',
  GlobalId = 'globalId',
}

// Prefixed to avoid the Auth0 SDK's reserved `clientId` key, which it rewrites
// to the app's client_id and never forwards.
export enum IsolvedAuthParamKeys {
  TenantId = 'isolvedTenantId',
  ClientId = 'isolvedClientId',
  GlobalId = 'isolvedGlobalId',
}

export const ISOLVED_CONNECTION_NAME = 'isolved';

export const ORG_SELECTOR_ENABLED_CONNECTIONS: string[] = [
  ISOLVED_CONNECTION_NAME,
];

export const JUSTWORKS_CONNECTION_NAME = 'justworks';
export const PAYCHEX_CONNECTION_NAME = 'paychex';
export const LOGIN_HINT_PARAM = 'login_hint';

export enum ThemingParamKeys {
  Theme = 'theme',
}

export const ModalParamKeys = {
  AssetsCsvUpload: 'assets-csv-upload',
  AddPaymentMethod: 'add-payment-method',
} as const;

/** ID of the ABM Management section on the Device Settings page, used for scroll-to navigation */
export const ABM_MANAGEMENT_SECTION_ID = 'abm-management-section';

export const InternalBillingParamKeys = {
  CustomerId: 'customerId',
  QuoteId: 'quoteId',
  Step: 'step',
} as const;

/** Just an object representation of a queryParam (can be used both for URL or API call query params) */
export type QueryParam = {
  key: string;
  value?: string;
};

export const AssetEventsHistoryQueryParams = {
  EventTypes: 'eventType',
  Categories: 'category',
  PageCursorDate: 'pageCursorDate',
  SortOrder: 'sortOrder',
} as const;
